<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/invoice/applyList',title:'发票管理'},{title:'对账列表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">

                        <el-form-item label="供应商">
                            <el-input v-model="q.supplierCode" placeholder="请输入编码或名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="公司主体">
                            <brselect
                                      category="kkber_value" v-model="q.companyCode"
                                      :v="q.companyCode" :clearable="true"></brselect>
                        </el-form-item>



                    </el-form>
                    <div class="l-screenBox">
                       <!-- <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                        </div>-->
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;" v-if='_user.usertype != "0"' @click="createApply">
                                申请开票
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <createApply
                    :visible.sync="showAddDialog"
                    v-if="showAddDialog"
                    @saveorsubmit="closeDialog"
                    title="开票明细"/>
            <updateApply
                    :apply-id="id"
                    :visible.sync="showUpdateDialog"
                    v-if="showUpdateDialog"
                    @saveorsubmit="closeDialog"
                    title="开票明细"/>
            <createInvoiceInfo
                    :applyList="multipleSelection"
                    :totalMoney="totalMoney"
                    :includeTaxAmount="includeTaxAmount"
                    :taxCode="taxCode"
                    :currency="currency"
                    :supplierCode="supplierCode"
                    :supplierName="supplierName"
                    :companyCode="companyCode"
                    :visible.sync="showInvoiceDialog"
                    v-if="showInvoiceDialog"
                    @saveorsubmit="closeDialog"
                    title=""/>

            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData"
                        stripe
                        style="width: 100%"
                        :border="true"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                            fixed
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="序号"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="supplierCode"
                            label="供应商编号"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="supplierName"
                            label="供应商名称"
                            width="220">
                    </el-table-column>
                  <el-table-column
                      prop="companyCode"
                      label="对账公司"
                      width="120">
                  </el-table-column>
                  <el-table-column
                      prop="companyCode"
                      label="对账公司名称"
                      width="220">
                    <template slot-scope="scope">
                      <dictname category="kkber_value" :v="scope.row.companyCode"/>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="includeTaxAmount"
                      label="总金额"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="includeTaxAmountY"
                      label="已确认金额"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="includeTaxAmountN"
                      label="未确认金额"
                      width="180">
                  </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="180"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    type="text"
                                    size="small"
                                    @click="getDetail(scope.row)"
                                    class="h-tableLink h-btn">
                                查看
                            </el-button>
<!--                            <el-button-->
<!--                                    v-if="(scope.row.status == 0 || scope.row.status == -1)&&_user.usertype =='2'"-->
<!--                                    type="text"-->
<!--                                    size="small"-->
<!--                                    @click="editPage(scope.row.id)"-->
<!--                                    class="h-tableLink h-btn">-->
<!--                                编辑-->
<!--                            </el-button>-->
<!--                            <el-button-->
<!--                                    v-if="(scope.row.status == 0 || scope.row.status == -1 || scope.row.status == 1  || scope.row.status == 2)&&_user.usertype =='2'"-->
<!--                                    type="text"-->
<!--                                    size="small"-->
<!--                                    @click="deleteApply(scope.row.id)"-->
<!--                                    class="h-tableLink h-btn">-->
<!--                                删除-->
<!--                            </el-button>-->
<!--                            <el-button-->
<!--                                    v-if="_user.usertype == '0'"-->
<!--                                    type="text"-->
<!--                                    size="small"-->
<!--                                    @click="topay(scope.row.id)"-->
<!--                                    class="h-tableLink h-btn">-->
<!--                                付款-->
<!--                            </el-button>-->
<!--                            <el-button v-if="scope.row.instId != null && scope.row.instId != '' "-->
<!--                                       size="small" class="h-tableLink h-btn"-->
<!--                                       @click="genzongLiuch(scope.row)">-->
<!--                                跟踪-->
<!--                            </el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
              <div class="h-tableB h-mrt30">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">导出</el-button>
                <pagination :page="q" @query="checkData"/>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import createPayment from '../../../components/invoice/createPayment'
    import createApply from './../createApply'
    import searchApplyNew from './../apply/searchApplyNew'
    import updateApply from './../updateApply'
    import createInvoiceInfo from './../createInvoiceInfo'

    import big from 'big.js'
    import updownfile from "../../../utils/updownfile";
    export default {
        components: {createApply,searchApplyNew,updateApply,createInvoiceInfo,createPayment},
        data() {
            return {
                //查询属性
                page:{
                    pageSize:20,
                    pageNo:1
                },
                q: {
                  pageSize: 10,
                  pageNo: 1,
                  total: 0
                },
                f:{
                  supplierCode:null,
                  supplierName:null,
                  org:null,
                  includeTaxAmount:null,
                },
                id:null,
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //table列表
                tableData: [],
                showAddDialog:false,
                showSearchDialog:false,
                showUpdateDialog:false,
                showInvoiceDialog:false,
                //操作标志
                optflag:'save',
                ddhB:'',
                showhistory:false,
                instid:'',
                totalMoney:0.0,//选中数据不含税金额累加
                includeTaxAmount:0.0,//选中数据含税金额累加
                taxCode:'',
                currency:'',
                supplierCode:'',
                supplierName:'',
                companyCode:'',
                multipleSelection:[],//选中的数据
                showNewFukuan:false,
                cgCode:'',
                org:'',
            }
        },
        created() {
            this.query();
        },
        methods: {
            query() {
                ss.invoiceApplyList.invoiceList(this.q).then(rd=>{
                  console.log(rd,"rd");
                  this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //跟踪流程
            genzongLiuch(v) {
                this.instid = v.instId;
                this.showhistory = true;
            },
            //查询
            getDetail(row){
              console.log(row);
                let query = row;
                this.$router.push({path: '/invoice/searchApplyNew', query: query});
            },
            editPage(id){
                this.id = id;
                this.showUpdateDialog = true;
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            closeDialog(){
                this.showAddDialog=false;
                this.showUpdateDialog = false;
                this.showInvoiceDialog=false;
                this.query();
            },
            //检索按钮功能
            checkData(){
                this.query();
            },
            createApply(){
                this.showAddDialog=true;
            },

            topay(o){
                //TODO
                this.cgCode = o;
                this.showNewFukuan = true;
            },
            handleFilter() {
                this.query();
            },
            //重置按钮功能
            resetData(){
              var pageSize=this.q.pageSize;
              var pageNo=this.q.pageNo;
              var total=this.q.total;
              this.q= {
                supplierCode:null,
                companyCode:null,
                pageSize: pageSize,
                pageNo: pageNo,
                total:total,
              }
            },
            deleteApply(id){
                this.$msg.confirm("确认删除",()=>{
                    ss.invoiceApplyList.deleteApply({id:id}).then(rd=>{
                        this.query();
                    })
                })
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.totalMoney=0.0;
                this.includeTaxAmount=0.0;
                this.multipleSelection.forEach(element => {
                    this.totalMoney=parseFloat(new big(this.totalMoney).plus(element.totalMoney).toFixed(2));
                    this.includeTaxAmount=parseFloat(new big(this.includeTaxAmount).plus(element.includeTaxAmount).toFixed(2));
                });
                if(this.multipleSelection.length>0) {
                    this.taxCode = this.multipleSelection[0].taxCode;
                    this.currency=this.multipleSelection[0].currency;
                    this.supplierCode=this.multipleSelection[0].supplierCode;
                    this.supplierName=this.multipleSelection[0].supplierName;
                    this.companyCode=this.multipleSelection[0].companyCode;
                }


            },
          //导出
            exportExcel(){
              var q = this.q;
              q.id=this.id;
              updownfile.down("/api/swyl/v1/demo/bscSrmInvoiceDetail/downloadExcelAll",q,"get",'params');
            },
            choseObj() {
                this.showNewFukuan = false;
            }

        }
    }
</script>